var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 5.5,
    stroke: "#D4D7DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#C77AC4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.5 10A5.5 5.5 0 1 0 10 4.5"
  })));
};
export default SvgLoading;